import classNames from 'classnames';
import React, { memo, useContext } from 'react';
import { QuickQuoteContext } from '../../contexts/QuickQuote.context';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';

interface QuickQuotePreviousCTAProps {
  label: string;
  onClick?: (() => void) | ((e: React.MouseEvent<HTMLElement>) => void);
}

const QuickQuotePreviousCTA: React.FC<QuickQuotePreviousCTAProps> = ({
  label,
  onClick,
}) => {
  const { setService, setQuoteStep, quoteStep } = useContext(QuickQuoteContext);
  return (
    <div className="flex justify-center pt-4">
      {label && (
        <button
          className={classNames('flex items-center font-bold', {
            hidden: quoteStep === 0,
          })}
          onClick={onClick}
          type="button"
        >
          <span className="block h-[16px] w-[16px] bg-[url('/svgs/arrow-previous.svg')] mb-[2px] bg-no-repeat ml-2" />
          {label.toUpperCase()}
        </button>
      )}
    </div>
  );
};

export default memo(withBlokWrapper(QuickQuotePreviousCTA, Theme.ALT));
